<script setup>
import { ref, defineProps } from 'vue';
import InfoBoxBottom from '@/components/cloudCounter/InfoBoxBottom.vue';

const props = defineProps({
    timeValue: String,
    setTimeValue: Function,
    placeholder: String,
    boxData: Object
});

const infoBoxVisible = ref(false);

const showInfoBox = () => {
    if (props.boxData.options.length >= 1) {
        infoBoxVisible.value = true;
    }
}

</script>

<template>

    <div class="flex justify-between p-3 w-full border rounded-md cursor-pointer bg-white" @click="showInfoBox">
        <div class="flex-1">
            <template v-if="timeValue">{{ timeValue }}</template>
            <template class="text-[]" v-else>{{ placeholder || '-' }}</template>
        </div>
        <div v-if="boxData?.options?.length >= 1">
            <svg fill="#0093C1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                style="width: 24px; height: 24px;">
                <title>chevron-down</title>
                <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
            </svg>
        </div>
    </div>

    <InfoBoxBottom v-show="infoBoxVisible" :boxTitle="boxData?.boxTitle"
        :closeHandle="(e) => { infoBoxVisible = false; }">
        <ul>
            <li v-for="(option, i) in boxData?.options" :key="i" :class="{ 'border-t border-[#DADADA]': i !== 0 }">
                <button class="w-full py-4 text-left cursor-pointer"
                    @click="(e) => { setTimeValue(option); infoBoxVisible = false; }">{{ option }}</button>
            </li>
        </ul>
    </InfoBoxBottom>

</template>

<style scoped></style>
